import {useEffect, useState} from 'react';

import {readComposeAttachments} from '../../outlookComposeItem';
import {subscribeToSendDialogAttachments} from '../../sendDialogParentMessages';
import type {MessageAttachment} from './structs';

const dedupeById = (attachments: MessageAttachment[]): MessageAttachment[] => {
  const seen = new Set<string>();
  const out: MessageAttachment[] = [];
  for (const attachment of attachments) {
    if (seen.has(attachment.id)) {
      continue;
    }
    seen.add(attachment.id);
    out.push(attachment);
  }
  return out;
};

export const useComposeMessageAttachments = (): MessageAttachment[] => {
  const [attachments, setAttachments] = useState<MessageAttachment[]>([]);

  useEffect(() => {
    const hasDialogParent =
      typeof (Office.context?.ui as {messageParent?: unknown} | undefined)
        ?.messageParent === 'function';
    if (!hasDialogParent) {
      void readComposeAttachments().then((next) => {
        setAttachments(dedupeById(next));
      });
      return;
    }

    return subscribeToSendDialogAttachments((next) => {
      setAttachments(dedupeById(next));
    });
  }, []);

  return attachments;
};
